<style>
#AddCurvePattern .v--modal-box.v--modal {
  min-height: 400px !important;
  min-width: 250px !important;
}
#AddCurvePattern .v-card.v-card--flat.v-sheet.theme--light {
  height: 100% !important;
}
</style>

<template>
  <Modal
    modalName="AddCurvePattern"
    :title="isCurve ? 'Dodawanie krzywej': 'Dodawanie wzorca'"
    @closed="close"
    @saved="saveCurve"
    :buttons="['save']"
  >
    <v-layout>
      <v-flex xs3>
        <v-text-field
          label="ID"
          v-model="curveID"
        ></v-text-field>
      </v-flex>
      <v-spacer />
      <v-flex xs8>
        <v-text-field
          v-model="description"
          label="Opis"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout v-if="isCurve">
      <v-flex xs3>
        <v-select
          label="Typ krzywej"
          :items="curveTypes"
          v-model="chosenCurveType"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-subheader>Dodawanie wartości</v-subheader>
    </v-layout>
    <v-layout>
      <v-flex xs5>
        <v-text-field
          :label="isCurve ? 'Flow' : 'Czas'"
          type="number"
          v-model="newX"
        ></v-text-field>
      </v-flex>
      <v-spacer />
      <v-flex xs5>
        <v-text-field
          :label="isCurve ? 'Head' : 'Współczynnik'"
          type="number"
          v-model="newY"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-spacer />
      <v-flex xs3>
        <v-btn
          color="#2a579a"
          @click="addValues"
          style="float: right; margin-right: 0"
          dark
        >DODAJ WARTOŚĆ</v-btn>
      </v-flex>
    </v-layout>
    <v-layout v-if="newValuesList.length > 0">
      <v-subheader>Lista dodawanych wartości</v-subheader>
    </v-layout>
    <v-layout v-if="newValuesList.length > 0">
      <v-flex xs12>
        <ul>
          <li
            style="display:flex; justify-content: space-between"
            class="list--el"
            v-for="(el, index) in newValuesList"
          >
            <span v-if="isCurve">Wartość X: {{el.x}}, Wartość Y: {{el.y}}</span>
            <span v-else>Czas: {{el.x}}, Współczynnik: {{el.y}}</span>
            <span>
              <v-icon @click="removeNewValue(index)">delete</v-icon>
            </span>
          </li>
        </ul>
      </v-flex>
    </v-layout>
  </Modal>
</template>

<script>
import Modal from '../../../shared/Modal';

export default {
  components: {
    Modal
  },
  data: () => ({
    curveTypes: [
      'VOLUME',
      'PUMP',
      'EFFICIENCY',
      'HEADLOSS'
    ],
    chosenCurveType: undefined,
    curveID: undefined,
    description: undefined,
    newX: undefined,
    newY: undefined,
    newValuesList: [],
    isCurve: true
  }),
  methods: {
    addValues() {
      this.newValuesList.push({x: this.newX, y: this.newY});
      this.newX = undefined;
      this.newY = undefined
    },
    removeNewValue(index) {
      this.newValuesList.splice(index, 1);
    },
    saveCurve() {
      let curve_type;
      if(this.isCurve) {
        if(this.chosenCurveType == 'VOLUME') {
          curve_type = 1
        } else if(this.chosenCurveType == 'PUMP') {
          curve_type = 2
        } else if(this.chosenCurveType == 'EFFICIENCY') {
          curve_type = 3
        } else if(this.chosenCurveType == 'HEADLOSS') {
          curve_type = 4
        }
      } else {
        curve_type = 0;
      }

      if(!this.curveID) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Podaj ID"
        );
        return;
      }
      if(!this.description) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Podaj opis"
        );
        return;
      }
      if(!this.chosenCurveType && this.isCurve) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Wybierz typ krzywej"
        );
        return;
      }
      if(this.newValuesList.length < 1) {
        this.$root.$emit(
          "showSnackbar",
          "red",
          "Podaj dane"
        );
        return;
      }
      let payload = {
        curve_id: this.curveID,
        curve_type: curve_type,
        data: this.newValuesList,
        description: this.description
      }
      this.$store.dispatch("addNewCurve", payload).then(r => {
        if(r) {
          this.$modal.hide("AddCurvePattern");
          if(this.isCurve) {
            this.$root.$emit('refreshCurves');
          } else {
            this.$root.$emit('refreshPatterns');
          }

        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            `${r}`
          );
        }
      });
    },
    changeCurveType(data) {
      this.isCurve = data;
    },
    close() {
      this.description = undefined;
      this.chosenCurveType = undefined;
      this.curveID = undefined;
      this.newX = undefined;
      this.newY = undefined;
      this.newValuesList = [];
    }
  },
  mounted() {
    this.$root.$on('emittingCurveType', this.changeCurveType)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/AddCurvePattern.vue